<div class="supplementary-box" [ngClass]="{'selected': selected}">
    <h3 class="w-100 text-center custom-h3 mb-4">{{ garanzia.name }}</h3>
    <app-check-mark [hidden]="!selected"></app-check-mark>
    <img class="menu-icon d-table mb-4" [src]="'assets/img/icons-colored/' + garanzia.configuration.icon"/>
    <p class="text-center">{{ getDescription() }}</p>
    <p class="text-center" [hidden]="!preventivo_info.public_token">{{ (getAgenzia()?.name || (this.window.config.title || "")) }}</p>
    <p class="text-center" [hidden]="!preventivo_info.public_token">{{ window.dictionary.get('prezzo_offerto') }} <br><b>{{ getPriceTable() }}</b></p>
</div>